<template>
	<table class="table table-responsive table-hover admin-table">
		<thead>
			<tr>
				<th>Imagen</th>
				<th>Nombre del producto</th>
				<th>SKU</th>
				<th>Categoría</th>
				<th>Subcategoría</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr class="clickable-row" v-for="item in render_list | filterBy query">
				<td><img :src="item.images[0].route" class="table-img" alt="Product image."></td>
				<td>{{ item.name }}</td>
				<td>{{ item.sku }}</td>
				<td>{{ (item.category.parents) ? item.category.parents.name : item.category.name }}</td>
				<td>{{ item.category.name }}</td>
				<td>
					<i class="fa fa-pencil" aria-hidden="true" v-link="{ path: '/admin/products/edit/' + item.id }"></i>
					<i class="fa fa-trash" aria-hidden="true" @click="remove(item)"></i>
				</td>
			</tr>
		</tbody>
	</table>
	<div v-if="!list.length" class="text-center empty">No hay productos en la plataforma.</div>
	<!-- <pagination></pagination> -->
</template>

<script>
export default {
	// ---- PROPS ----

	props: ['list', 'url', 'remove', 'query'],

	// ---- DATA ----
	
	data() {
		return {};
	},

	// ---- RENDER ----

	computed: {
		render_list() {
			return this.list;
		},

		render_url() {
			return this.url;
		}
	}
}
</script>


// WEBPACK FOOTER //
// Admin-table-prod.vue?3fd3292e